import { useNavigate } from "react-router-dom";

import GradientButton from "./buttonUI/GradientButton";
import ButtonIcon from "./buttonUI/ButtonIcon";
import { RotateCcw, LogIn, House } from "lucide-react";
import LeftIconButton from "./buttonUI/LeftIconButton";
import LogoutAction from "../auth/LogoutAction";

export default function DialogBox(props) {
  const navigate = useNavigate();
  const {
    title,
    message,
    phoneNo,
    messageIcon,
    animateIcon,
    btnText,
    closeAction,
    isErrorHandleButtons,
    isHome,
  } = props;

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="overlay before:z-9999">
      <div className="flex-center-align dialogBoxWrap absolute-center-align">
        <div>
          {animateIcon && (
            <div className="animateSpin" viewBox="0 0 24 24">
              <img src={animateIcon} alt="animateIcon" />
            </div>
          )}
          {messageIcon && (
            <img src={messageIcon} alt="messageIcon" className="mx-auto mb-5 w-10" />
          )}
          {title && <h3 className="dialogBoxTitle">{title}</h3>}
          <p className="dialogBoxMsg">{message}</p>
          {phoneNo && <p className="dialogBoxPhone">{phoneNo}</p>}
          {btnText && (
            <div className="mt-5">
              <GradientButton btnText={btnText} onClick={closeAction} />
            </div>
          )}
          {isErrorHandleButtons && (
            <p className="flex justify-center pt-8 gap-2">
              {!isHome && message !== "Network Error" && (
                <ButtonIcon
                  btnText="Go to Home"
                  Icon={House}
                  size={15}
                  onclick={() => navigate("/")}
                />
              )}
              {isHome && (
                <LogoutAction>
                  {({ onLogout, loading }) => (
                    <ButtonIcon
                      btnText={loading ? "Logging out..." : "Logout"}
                      Icon={LogIn}
                      size={16}
                      disabled={loading}
                      onclick={onLogout}
                    />
                  )}
                </LogoutAction>
              )}
              <LeftIconButton
                text="Try Again"
                btnStyle="text-dark-blue bg-lg5 hover:bg-gray-200 text-xs"
                Icon={RotateCcw}
                size={16}
                onClick={handleReload}
              />
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
